const METRICS_PREFIX = 'onboarding.video.'

export const countAppMetric = (metricName) => ({
  metric: METRICS_PREFIX + metricName,
  value: 1,
  dimensions: {
    type: 'counter',
  }
})
